export enum NewMenuEnum {
  PRODUCT_COLLECTIONS = "productCollections",
}

export default NewMenuEnum;
